<div class="login">
    <div class="login--center">
        <div class="login--center-panel">
            <div class="brand_name">
                <!-- Pro Suite -->
            </div>

            <div class="panel">
                <div class="access">
                    <div class="access--login">
                        @if(!selectTenants) {
                            <!-- LOGIN FORM -->
                            <div class="login_form">
                                @if (isAltLogin) {
                                    <h3 class="mb-3">{{auth0TenantName}} Authentication</h3>
                                }
                                
                                <button *sm-has-not-env-flag="'auroraV1'"
                                        unity-button class="primary block"
                                        id="loginButton"
                                        [class.py-4]="isAltLogin"
                                        (click)="onLoginClick.emit()">
                                    {{ isAltLogin ? `Login with ${ auth0TenantName } Auth0` : 'Login' }}
                                </button>
                                <aurora-button *sm-has-env-flag="'auroraV1'"
                                        block
                                        variant="primary"
                                        [class.py-4]="isAltLogin"
                                        id="loginButton"
                                        (click)="onLoginClick.emit()">
                                    {{ isAltLogin ? `Login with ${ auth0TenantName } Auth0` : 'Login' }}
                                </aurora-button>
                                @if (errorMessage) {
                                    <div id="loginError" class="alert alert-danger mt-2">
                                        Login failed: {{ errorMessage }}
                                    </div>
                                }
                                @if (isAltLogin) {
                                    <div class="mt-3">
                                        <button *sm-has-not-env-flag="'auroraV1'" unity-button class="link nav-item"
                                                (click)="onGoToPrimaryLogin.emit()">
                                            &#8592; Back to Primary Login
                                        </button>
                                        <aurora-link-button *sm-has-env-flag="'auroraV1'" class="nav-item"
                                                (click)="onGoToPrimaryLogin.emit()">
                                            &#8592; Back to Primary Login
                                        </aurora-link-button>
                                    </div>
                                }
                            </div>
                        } @else {
                            <!-- SELECT TENANT -->
                            <select-tenant
                                [selectedTenant]="selectedTenant"
                                [tenants]="tenants"
                                (onTenantSelect)="tenantSelect($event)"
                                (onChangeUser)="onChangeUser.emit()">
                            </select-tenant>
                        }
                    </div>
                    @if (loading) {
                        <unity-loading-indicator [display]="UnityLoadingIndicatorDisplayEnum.Overlay"/>
                    }
                </div>
            </div>

            <footer>
                <a href="https://insurity.com" target="_blank">
                    <img src="assets/logo-insurity-white.svg"
                         alt="Insurity, LLC logo"
                         class="insurity_logo" />
                </a>
            </footer>

        </div>
    </div>
</div>
